import { CompanyNode, DepartmentNode } from 'features/common/models';
import { ListGroup } from 'react-bootstrap';
import { isCompanyNode } from 'utils';
import { DepartmentMenuItem } from './DepartmentMenuItem';

export interface DepartmentMenuProps {
  data: Array<CompanyNode> | Array<DepartmentNode>;
}

export function DepartmentMenu({ data }: DepartmentMenuProps) {
  return (
    <ListGroup>
      {data.map(function (item) {
        return (
          <DepartmentMenuItem
            key={isCompanyNode(item) ? item.company_cd : (item as DepartmentNode).department_cd}
            data={item}
          />
        );
      })}
    </ListGroup>
  );
}
